import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CustomerProvider } from "@/context/CustomerContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import { DealerAuthProvider } from "@/context/DealerAuthContext";

import CustomerLayout from "@/components/customer/CustomerLayout";
import Home from "@/pages/customer/Home";
import Chat from "@/pages/customer/Chat";
import MyCaravan from "@/pages/customer/MyCaravan";
import Manuals from "@/pages/customer/Manuals";
import CustomerDocuments from "@/pages/customer/Documents";
import CustomerServiceBulletins from "@/pages/customer/ServiceBulletins";
import WiringDiagrams from "@/pages/customer/WiringDiagrams";
import Videos from "@/pages/customer/Videos";
import SystemGuides from "@/pages/customer/SystemGuides";
import Repairers from "@/pages/customer/Repairers";
import Warranty from "@/pages/customer/Warranty";
import ClaimStatus from "@/pages/customer/ClaimStatus";
import ContactSupport from "@/pages/customer/ContactSupport";

import AdminLayout from "@/components/admin/AdminLayout";
import AdminLogin from "@/pages/admin/AdminLogin";
import Dashboard from "@/pages/admin/Dashboard";
import Conversations from "@/pages/admin/Conversations";
import ConversationDetail from "@/pages/admin/ConversationDetail";
import Feedback from "@/pages/admin/Feedback";
import KnowledgeBase from "@/pages/admin/KnowledgeBase";
import Documents from "@/pages/admin/Documents";
import AdminManuals from "@/pages/admin/AdminManuals";
import AdminServiceBulletins from "@/pages/admin/AdminServiceBulletins";
import CaravanDatabase from "@/pages/admin/CaravanDatabase";
import AdminDealers from "@/pages/admin/AdminDealers";
import AdminRepairers from "@/pages/admin/AdminRepairers";
import AdminSubmissions from "@/pages/admin/AdminSubmissions";
import AdminSuppliers from "@/pages/admin/AdminSuppliers";
import AdminHubTypes from "@/pages/admin/AdminHubTypes";
import AdminModelSpecs from "@/pages/admin/AdminModelSpecs";
import AdminWarrantyClaims from "@/pages/admin/AdminWarrantyClaims";
import AdminDiscrepancies from "@/pages/admin/AdminDiscrepancies";
import AdminSupportTickets from "@/pages/admin/AdminSupportTickets";
import AdminProductionSync from "@/pages/admin/AdminProductionSync";
import AdminModelPhotos from "@/pages/admin/AdminModelPhotos";
import AdminVideos from "@/pages/admin/AdminVideos";
import AdminDealerPortal from "@/pages/admin/AdminDealerPortal";
import Settings from "@/pages/admin/Settings";

import DealerLogin from "@/pages/dealer/DealerLogin";
import DealerBoard from "@/pages/dealer/DealerBoard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          <CustomerProvider>
            <Routes>
              <Route element={<CustomerLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/chat" element={<Chat />} />
                <Route path="/my-caravan" element={<MyCaravan />} />
                <Route path="/manuals" element={<Manuals />} />
                <Route path="/documents" element={<CustomerDocuments />} />
                <Route path="/service-bulletins" element={<CustomerServiceBulletins />} />
                <Route path="/wiring-diagrams" element={<WiringDiagrams />} />
                <Route path="/videos" element={<Videos />} />
                <Route path="/guides" element={<SystemGuides />} />
                <Route path="/repairers" element={<Repairers />} />
                <Route path="/warranty" element={<Warranty />} />
                <Route path="/claim-status" element={<ClaimStatus />} />
                <Route path="/support" element={<ContactSupport />} />
              </Route>

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="conversations" element={<Conversations />} />
                <Route path="conversations/:id" element={<ConversationDetail />} />
                <Route path="feedback" element={<Feedback />} />
                <Route path="knowledge" element={<KnowledgeBase />} />
                <Route path="documents" element={<Documents />} />
                <Route path="manuals" element={<AdminManuals />} />
                <Route path="service-bulletins" element={<AdminServiceBulletins />} />
                <Route path="caravans" element={<CaravanDatabase />} />
                <Route path="production-sync" element={<AdminProductionSync />} />
                <Route path="dealers" element={<AdminDealers />} />
                <Route path="repairers" element={<AdminRepairers />} />
                <Route path="suppliers" element={<AdminSuppliers />} />
                <Route path="hub-types" element={<AdminHubTypes />} />
                <Route path="model-specs" element={<AdminModelSpecs />} />
                <Route path="submissions" element={<AdminSubmissions />} />
                <Route path="warranty-claims" element={<AdminWarrantyClaims />} />
                <Route path="discrepancies" element={<AdminDiscrepancies />} />
                <Route path="support-tickets" element={<AdminSupportTickets />} />
                <Route path="dealer-portal" element={<AdminDealerPortal />} />
                <Route path="model-photos" element={<AdminModelPhotos />} />
                <Route path="videos" element={<AdminVideos />} />
                <Route path="settings" element={<Settings />} />
              </Route>

              <Route
                path="/dealer/login"
                element={
                  <DealerAuthProvider>
                    <DealerLogin />
                  </DealerAuthProvider>
                }
              />
              <Route
                path="/dealer/board"
                element={
                  <DealerAuthProvider>
                    <DealerBoard />
                  </DealerAuthProvider>
                }
              />
            </Routes>
            <Toaster position="bottom-right" theme="dark" richColors />
          </CustomerProvider>
        </AdminAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
